var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-container"},[_c('CarouselScheme',{attrs:{"carouselDataLoaded":_vm.carouselDataLoaded,"intervalValue":_vm.intervalValue,"typeCarousel":_vm.typeCarousel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }